import { ArrowHeavyIcon } from "@theme/assets";

import { NavLink, Text } from "@theme/components";

import type { ThemeUIStyleObject } from "@theme/components";
import type { FC } from "react";

interface NavShopAllLinkProps {
  to: string;
  text: string;
  ariaLabel: string;
  onClick?: () => void;
  sx?: ThemeUIStyleObject;
  className?: string;
}

export const NavShopAllLink: FC<NavShopAllLinkProps> = ({
  to,
  text,
  ariaLabel,
  onClick,
  sx,
  className,
}) => (
  <NavLink
    className={className}
    variant="box"
    to={to}
    onClick={onClick}
    aria-label={ariaLabel}
    sx={{
      display: "flex",
      gap: "s200",
      alignItems: "center",
      ...sx,
    }}
  >
    <Text
      variant="sansBody01Medium"
      sx={{
        color: "black",
      }}
    >
      {text}
    </Text>
    <ArrowHeavyIcon sx={{ color: "goldPrimary", ":hover": { color: "goldPrimary" } }} />
  </NavLink>
);
